import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { PageTitle } from '../../../_metronic/layout/core'
import { KTCard, KTCardBody } from '../../../_metronic/helpers'
import { KTIcon } from '../../../_metronic/helpers'
import { create_tag } from './api/tagsApi'
import { toast } from 'react-toastify'
import { permissionCheck } from '../../helper-functions/PermissionCheck'

const AddTagPage: React.FC = () => {
  const navigate = useNavigate()
  const [formData, setFormData] = useState({
    tag_title: '',
    description: '',
    status: 1
  })
  const [errors, setErrors] = useState<Record<string, string>>({})
  const [isSubmitting, setIsSubmitting] = useState(false)
  const canCreateTag = Boolean(permissionCheck('tag-create'))

  const validateForm = () => {
    const newErrors: Record<string, string> = {}

    if (!formData.tag_title.trim()) {
      newErrors.tag_title = 'Tag title is required'
    }

    setErrors(newErrors)
    return Object.keys(newErrors).length === 0
  }

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    
    if (!canCreateTag) {
      toast.error('You do not have permission to create tags')
      return
    }

    if (validateForm()) {
      try {
        setIsSubmitting(true)
        const payload = {
          tag_title: formData.tag_title.trim(),
          description: formData.description.trim(),
          status: String(formData.status)
        }
        await create_tag(payload)
        toast.success('Tag created successfully')
        navigate('/tags')
      } catch (error) {
        console.error('Error creating tag:', error)
        toast.error('Failed to create tag')
      } finally {
        setIsSubmitting(false)
      }
    }
  }

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target
    setFormData(prev => ({
      ...prev,
      [name]: value
    }))
    
    // Clear error when user starts typing
    if (errors[name]) {
      setErrors(prev => ({
        ...prev,
        [name]: ''
      }))
    }
  }


  if (!canCreateTag) {
    return (
      <>
        <PageTitle breadcrumbs={[]}>Add Tag</PageTitle>
        <div className='d-flex flex-column flex-lg-row'>
          <div className='flex-lg-row-fluid'>
            <KTCard>
              <KTCardBody>
                <div className='alert alert-warning mb-0'>
                  You do not have permission to create tags.
                </div>
              </KTCardBody>
            </KTCard>
          </div>
        </div>
      </>
    )
  }

  return (
    <>
      <PageTitle breadcrumbs={[]}>Add Tag</PageTitle>
      <div className='d-flex flex-column flex-lg-row'>
        <div className='flex-lg-row-fluid'>
          <KTCard>
          <div className='card-header'>
            <div className='card-title'>
              <h3 className='fw-bold text-dark'>Add New Tag</h3>
            </div>
            <div className='card-toolbar'>
              <button
                type='button'
                className='btn btn-sm btn-icon btn-active-color-primary'
                onClick={() => navigate('/tags')}
              >
                <KTIcon iconName='cross' className='fs-1' />
              </button>
            </div>
          </div>
          <KTCardBody>
            <form onSubmit={handleSubmit}>
              <div className='row mb-6'>
                <div className='col-lg-6'>
                  <label className='col-form-label fw-bold fs-6'>
                    <span className='text-danger'>*</span>Tag Title
                  </label>
                  <input
                    type='text'
                    name='tag_title'
                    className={`form-control form-control-solid ${errors.tag_title ? 'is-invalid' : ''}`}
                    placeholder='Enter tag title'
                    value={formData.tag_title}
                    onChange={handleChange}
                  />
                  {errors.tag_title && <div className='invalid-feedback'>{errors.tag_title}</div>}
                </div>
                <div className='col-lg-6'>
                  <label className='col-form-label fw-bold fs-6'>Status</label>
                  <select
                    name='status'
                    className='form-select form-select-solid'
                    value={formData.status}
                    onChange={handleChange}
                  >
                    <option value={1}>Active</option>
                    <option value={0}>Inactive</option>
                  </select>
                </div>
              </div>

              <div className='row mb-6'>
                <div className='col-lg-12'>
                  <label className='col-form-label fw-bold fs-6'>
                    Description
                  </label>
                  <textarea
                    name='description'
                    className={`form-control form-control-solid ${errors.description ? 'is-invalid' : ''}`}
                    rows={3}
                    placeholder='Enter tag description'
                    value={formData.description}
                    onChange={handleChange}
                  />
                  {errors.description && <div className='invalid-feedback'>{errors.description}</div>}
                </div>
              </div>


              <div className='d-flex justify-content-end'>
                <button
                  type='button'
                  className='btn btn-light me-3'
                  onClick={() => navigate('/tags')}
                  disabled={isSubmitting}
                >
                  Cancel
                </button>
                <button
                  type='submit'
                  className='btn btn-primary'
                  disabled={isSubmitting}
                >
                  {isSubmitting ? (
                    <>
                      <span className='spinner-border spinner-border-sm me-2' role='status' aria-hidden='true'></span>
                      Saving...
                    </>
                  ) : (
                    <>
                      <KTIcon iconName='check' className='fs-2' />
                      Save Tag
                    </>
                  )}
                </button>
              </div>
            </form>
          </KTCardBody>
        </KTCard>
        </div>
      </div>
    </>
  )
}

export { AddTagPage }

